import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import dataLoad from '../actions/data-load';
import Loyalty from '../components/loyalty';

function mapStateToProps(state) {
  return {
    typeValue: state.customerOrders.orderFilter.typeValue,
    ajaxStatuses: state.ajaxStatuses.dataLoad,
    balance: state.balance,
    user: state.user,
    customer: state.customer,
    payer: state.payerList.payerListing
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Loyalty);